;(function (angular, _) {
  'use strict'

  angular.module('kilo.common.directives')
    .directive('zlAttachement', AttachementDirective)

  AttachementController.$inject = ['$scope', 'DownloaderService', 'FileManager']

  function AttachementController ($scope, DownloaderService, FileManager) {
    var self = this
    self.$onInit = () => {
      _.extend(self, {
        downloadFile: downloadFile,
        removeFile: removeFile
      })

      init()
    }

    function init () {
    }

    /**
     * downloadFile - start the download in new tab
     * @param  {Object} file - file the file url
     * @return {type} window.open
     */
    function downloadFile (file) {
      return DownloaderService.downloadFile(file)
    }

    function removeFile (item) {
      self.items = _.filter(self.items, function (f) {
        return f._id !== item._id
      })
      $scope.$emit('formModified')
    }
  }

  AttachementDirective.$inject = []

  function AttachementDirective () {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/attachement/attachement.html',
      controllerAs: 'container',
      controller: AttachementController,
      transclude: true,
      scope: {},
      bindToController: {
        items: '=',
        deletion: '=',
        mini: '=',
        edit: '=',
        restore: '=',
        uploader: '='
      }
    }
  }
})(window.angular, window._)
